import React from 'react';

export const QuadrantItem = ({ item, quadrant, right, center, collapsed = false }) => {

    return (
        <>
            {collapsed &&
                <span className={`mb-0 ${right ? 'flex-row-reverse' : ''}`} id={quadrant.quadrant}>
                    <i className={`icon text-${quadrant.quadrant.toLowerCase()} ${center ? 'mr-1' : right ? 'ml-2' : 'mr-2'}`}>
                        <svg width="10" height="10"><circle cx="5" cy="5" r="5" fill={quadrant.color} /></svg>
                    </i>
                </span>
            }
            {!collapsed &&
                <div>
                    <h6 className={`text-reset text-capitalize mb-0 d-flex align-items-center ${right ? 'flex-row-reverse flex-md-row' : 'flex-md-row-reverse'}`} id={quadrant.quadrant} style={{ fontWeight: '500' }}>
                        <i className={`icon text-${quadrant.quadrant.toLowerCase()} ${right ? 'ml-1 ml-md-0 mr-md-2' : 'mr-1 mr-md-0 ml-md-2'}`}>
                            <svg width="6" height="6"><circle cx="3" cy="3" r="3" fill={quadrant.color}/></svg>
                        </i>
                        <span className="text-nowrap" style={{ lineHeight: '19px', paddingTop: '3px' }}>{item.name}</span>
                    </h6>
                </div>
            }
        </>
    )
}
